import { Star } from "lucide-react";

const RatingBreakdown = ({ data, overAllRating, image }) => {
  const ratingsArray = Array.isArray(data) ? data : data?.ratings || [];
  const logoUrl = image || null;

  if (!ratingsArray.length && !overAllRating) {
    return (
      <div className="bg-white  border border-gray-300 dark:border-gray-600 rounded-2xl p-6 transition-colors duration-300">
        <p className="text-gray-600 dark:text-gray-100">
          No rating data available.
        </p>
      </div>
    );
  }

  return (
    <div className="bg-white dark:bg-[#1e2430] border border-gray-300 dark:border-gray-600 rounded-2xl p-4 md:p-5 flex flex-col md:flex-row gap-5 items-stretch transition-all duration-300 -ml-1">
      {/* === Left Card (Logo / Rating / Mascot) === */}
      <div className="bg-orange-50 dark:bg-[#1e2430] border border-gray-300 dark:border-gray-600 rounded-2xl px-3 pt-3 pb-1 flex flex-col justify-between items-center md:w-[33%] w-full transition-colors duration-300">
        {/* Logo */}
        {logoUrl && (
          <div className="w-[180px]">
            <img
              src={logoUrl}
              alt="casino logo"
              className="w-full object-fill rounded-md"
            />
          </div>
        )}
        {/* Rating */}
        {overAllRating && (
          <div className="flex items-center gap-2 bg-white dark:bg-[#1e2430] px-4 py-2 rounded-xl my-4 transition-colors duration-300">
            <Star className="text-orange-500 fill-orange-500 w-5 h-5" />
            <span className="font-semibold text-gray-900 dark:text-gray-100 text-xl">
              {overAllRating}
            </span>
            <span className="text-gray-500 dark:text-gray-300 text-base">
              /5
            </span>
          </div>
        )}
        {/* Mascot */}
        {/* {mascotUrl && ( */}
        <img
          src={`${process.env.PUBLIC_URL}/assets/mascot.png`}
          alt="mascot"
          className="w-24 h-24 object-contain mt-1 mb-0"
        />
      </div>

      {/* === Right Side: Rating Bars === */}
      <div className="flex-1 w-full flex flex-col justify-center">
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-4 text-left">
          Rating Breakdown
        </h2>

        <ul className="space-y-2.5">
          {ratingsArray.map((r, i) => {
            const value = typeof r.rating === "number" ? r.rating : 0;
            const percent = Math.min(100, Math.max(0, (value / 5) * 100));

            return (
              <li key={i}>
                <div className="flex justify-between items-center mb-1">
                  <span className="text-gray-800 dark:text-gray-100 font-medium text-sm">
                    {r.label}
                  </span>
                  <span className="text-gray-700 dark:text-gray-100 font-medium text-sm">
                    {value}/5
                  </span>
                </div>

                <div className="w-full bg-gray-100 dark:bg-[#1e2430] rounded-full h-1.5 overflow-hidden">
                  <div
                    className="bg-blue-500 h-1.5 rounded-full"
                    style={{ width: `${percent}%` }}
                  />
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default RatingBreakdown;
